<template>
  <div class="activity-detail-body">
    <div class="activity-detail-head-body">
      <div>
        <span>
          <images
            :id="
              achvDetail.coverAttachment
                ? achvDetail.coverAttachment.attachmentId
                : ''
            "
          />
        </span>
        <!-- 审核 -->
        <img
          v-if="achvDetail.status == 'SYS0302'"
          src="@/assets/img/shenhezhong.png"
        />
        <!-- 未通过 -->
        <img
          v-if="achvDetail.status == 'SYS0303'"
          src="@/assets/img/weitongguo.png"
        />
        <p v-if="achvDetail.rewardPass">
          <span>
            <span>￥</span>{{ achvDetail.rewardAmount }}<span>万</span>
          </span>
        </p>
        <div>
          <strong>{{ achvDetail.achvName }}</strong>
          <p>
            <span>{{ achvDetail.fieldLevelOneName }}</span>
            <span>{{ achvDetail.industryLevelOneName }}</span>
            <span>{{ achvDetail.skillLevelOneName }}</span>
          </p>
          <div>
            <p>发布单位：{{ achvDetail.applierName }}</p>
            <p>更新时间：{{ achvDetail.updateTime }}</p>
            <p v-if="achvDetail.sceneId">
              关联榜单：<span @click="scenesDetail(achvDetail.sceneId)">{{
                achvDetail.sceneName
              }}</span>
            </p>
          </div>
          <div class="home-results-head-info">
            <div>
              <span
                ><a-icon type="eye" />{{
                  achvDetail.viewed ? achvDetail.viewed : 0
                }}人浏览</span
              >
              <span
                ><a-icon type="message" />{{
                  achvDetail.commented ? achvDetail.commented : 0
                }}条评论</span
              >
              <span
                ><a-icon type="share-alt" />{{
                  achvDetail.shared ? achvDetail.shared : 0
                }}次分享</span
              >
            </div>
            <p>
              分享至：
              <span @click="share('qzone')"
                ><img src="@/assets/img/fxkj.png"
              /></span>
              <span @click="share('qq')"
                ><img src="@/assets/img/fxqq.png"
              /></span>
              <span @click="share('db')"
                ><img src="@/assets/img/db.png"
              /></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="activity-detail-content-body">
      <div class="activity-detail-content-left-body">
        <div class="activity-detail-content-tab">
          <span :class="{ active: achvTabIndex == 0 }" @click="achvTabIndex = 0"
            >成果介绍</span
          >
          <a-badge
            :count="achvCommentNum"
            dot
            :offset="[5, 15]"
            :class="{ active: achvTabIndex == 1 }"
            @click="achvTabIndex = 1"
          >
            <span>评论({{ achvCommentNum }})</span>
          </a-badge>
        </div>
        <div class="activity-detail-content">
          <detail-content v-if="achvTabIndex == 0" :info="achvDetail" />
          <detail-discuss
            v-else
            :info="achvDetail"
            @comment-change="commentChange"
          />
        </div>
      </div>
      <div class="activity-detail-content-right-body">
        <span @click="noUrl"><img src="@/assets/img/ggimg.jpg" /></span>
        <div class="activity-detail-more">
          <div class="more-dynamic-title">
            <p>相似推荐</p>
            <span @click="dynamicAll">更多 ></span>
          </div>
          <div class="more-dynamic-list">
            <div
              v-for="item in achvList"
              :key="item.id"
              @click="achvDetailBtn(item.id)"
            >
              <p>{{ item.achvName }}</p>
              <div>
                <span>{{ item.applierName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import detailContent from "./components/detailContent.vue";
import detailDiscuss from "./components/detailDiscuss.vue";
import images from "@/page/components/image";
import {
  getAchvInfo,
  getAchvSimilar,
  achvCommentList,
  addAchvViewed, addAchvShared
} from "@/api/achv";
export default {
  components: {
    detailContent,
    detailDiscuss,
    images,
  },
  data() {
    return {
      achvTabIndex: 0,
      achvId: "",
      achvDetail: "",
      achvList: [],
      achvCommentNum: 0,
      shared:this.$route.query.shared
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.achvId = to.query.id;
        this.loadGetAchvInfo();
      },
      deep: true,
    },
  },
  mounted() {
    if(this.shared){
      addAchvShared(this.$route.query.id).then(res=>{
        this.$router.push({
          path: "/homeResults/detail",
          query: { id: this.achvId },
        });
      })
      return
    }
    this.achvId = this.$route.query.id;
    this.addViewed();
    this.loadGetAchvInfo();
    this.loadGetAchvSimilar();
    this.loadachvCommentList();
  },
  methods: {
    noUrl(){
      this.$message.warning("暂无跳转链接！")
    },
    addViewed() {
      addAchvViewed(this.achvId);
    },
    loadGetAchvInfo() {
      getAchvInfo(this.achvId).then((res) => {
        this.achvDetail = res.data;
      });
    },
    loadGetAchvSimilar() {
      let page = {
        size: 4,
        current: 1,
      };
      getAchvSimilar(page, this.achvId).then((res) => {
        this.achvList = res.data.records;
      });
    },
    achvDetailBtn(id) {
      this.$router.push({
        path: "/homeResults/detail",
        query: { id: id },
      });
    },
    dynamicAll() {
      this.$router.push("/homeResults/list");
    },
    commentChange() {
      this.loadachvCommentList();
    },
    loadachvCommentList() {
      let page = {
        size: 10,
        current: 1,
      };
      achvCommentList(page, this.achvId).then((res) => {
        this.achvCommentNum = res.data.total;
      });
    },
    share(type) {
      let achvDetail = this.achvDetail;
      let url =
        window.location.origin +
        window.location.pathname +
        `?id=${this.achvId}&shared=${type}`;
      //qq空间分享接口
      if (type == "qzone") {
        window.open(
          `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}`
        );
      }
      //qq好友接口的传参
      if (type == "qq") {
        window.open(
          `http://connect.qq.com/widget/shareqq/index.html?url=` +
            encodeURIComponent(window.location.href) +
            `?sharesource=qzone&title=${achvDetail.achvName}&pics=图片地址&summary=${achvDetail.description}`
        );
      }
      if (type == "db") {
        window.open(
          `http://shuo.douban.com/!service/share?href=` +
            encodeURIComponent(window.location.href) +
            `&name=${achvDetail.achvName}&text=${achvDetail.description}&image=图片地址&starid=0&aid=0&style=11`
        );
      }
    },
    scenesDetail(id) {
      this.$router.push({
        path: "/homeScenes/detail",
        query: { id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.activity-detail-head-body {
  background: url(../../assets/img/resultsbg.jpg) no-repeat;
  background-size: 100% 100%;
  color: #fff;
  > div {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    position: relative;
    > img {
      display: block;
      max-width: 100%;
      position: absolute;
      top: 24px;
      right: 40px;
    }
    > span {
      width: 210px;
      height: 120px;
      margin-right: 24px;
      > img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    > p {
      position: absolute;
      top: -3px;
      right: 0;
      width: 160px;
      height: 143px;
      background: url(../../assets/img/resultsbg2.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        display: flex;
        align-items: flex-end;
        font-size: 30px;
        line-height: 24px;
        > span {
          font-size: 16px;
          line-height: 16px;
        }
      }
    }
    > div {
      flex: 1;
      > strong {
        display: block;
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 16px;
      }
      > p {
        display: flex;
        > span {
          height: 22px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 2px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      > div {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        > p {
          line-height: 14px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 16px;
          margin-right: 40px;
          > span {
            color: #1abc9c;
            cursor: pointer;
          }
        }
      }
      .home-results-head-info {
        justify-content: space-between;
        margin-top: 40px;
        > div {
          display: flex;
          > span {
            margin-right: 40px;
            color: #fff;
            opacity: 0.4;
            display: flex;
            align-items: center;
            font-size: 12px;
            line-height: 12px;
            > i {
              margin-right: 6px;
              font-size: 14px;
            }
          }
        }
        > p {
          margin: 0;
          display: flex;
          align-items: center;
          > span {
            margin-left: 4px;
            > img {
              display: block;
            }
          }
        }
      }
    }
  }
}
.activity-detail-content-body {
  display: flex;
  width: 1200px;
  margin: 24px auto 0;
  padding-bottom: 40px;
  .activity-detail-content-left-body {
    background: #fff;
    flex: 1;
    .activity-detail-content-tab {
      display: flex;
      padding: 0 24px;
      border-bottom: 1px solid #f0f0f0;
      > span {
        height: 48px;
        margin-right: 40px;
        line-height: 48px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        &.active {
          border-color: #1abc9c;
          color: #1abc9c;
        }
      }
    }
    .activity-detail-content {
      padding: 24px;
    }
  }
  .activity-detail-content-right-body {
    width: 280px;
    margin-left: 24px;
    > button {
      width: 100%;
      height: 48px;
      background: #1abc9c !important;
      border-color: #1abc9c !important;
      border-radius: 2px;
      margin-bottom: 30px;
      color: #fff;
    }
    .activity-detail-fx {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      > span {
        font-size: 12px;
        color: #8c8c8c;
      }
      > p {
        display: flex;
        align-items: center;
        > span {
          margin-left: 6px;
          cursor: pointer;
          > img {
            display: block;
          }
        }
      }
    }
    > span {
      display: block;
      cursor: pointer;
      margin-bottom: 24px;
      > img {
        display: block;
      }
    }
    .activity-detail-more {
      background: #fff;
      .more-dynamic-title {
        height: 48px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        > p {
          font-size: 16px;
        }
        > span {
          font-size: 12px;
          color: #8c8c8c;
        }
      }
      .more-dynamic-list {
        padding: 0 16px;
        > div {
          border-bottom: 1px solid #f0f0f0;
          padding: 16px 0;
          cursor: pointer;
          > p {
            line-height: 14px;
            margin-bottom: 16px;
          }
          > div {
            display: flex;
            > span {
              margin-right: 16px;
              font-size: 12px;
              line-height: 12px;
              color: #8c8c8c;
              display: flex;
              align-items: center;
              > i {
                font-size: 14px;
                margin-right: 8px;
              }
            }
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
}
.activity-detail-head-fixed-body {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.08);
  > div {
    width: 1200px;
    margin: 0 auto;
    padding: 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > strong {
      font-size: 20px;
      line-height: 20px;
    }
    > p {
      display: flex;
      align-items: center;
      > span {
        font-size: 12px;
        color: #8c8c8c;
        display: flex;
        align-items: center;
        margin-right: 24px;
        > i {
          margin-right: 8px;
        }
      }
      > button {
        width: 280px;
        height: 40px;
        background: #1abc9c !important;
        border-color: #1abc9c !important;
        border-radius: 2px;
        color: #fff;
      }
    }
  }
}
</style>
<style>
.before-content-body {
  background: #f7f7f7;
}
</style>
